import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=2639fa58&scoped=true&"
import script from "./DatePicker.vue?vue&type=script&lang=js&"
export * from "./DatePicker.vue?vue&type=script&lang=js&"
import style0 from "v-calendar/lib/v-calendar.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./DatePicker.vue?vue&type=style&index=1&id=2639fa58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639fa58",
  null
  
)

export default component.exports